import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className, once = true, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-10% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Lines = ({ lines, className, lineClassName = "", delay = 0, stagger = 0.09, as: Tag = "h1", inView = true }) => {
  const anim = inView
    ? { whileInView: { y: 0 }, viewport: { once: true, margin: "-10% 0px" } }
    : { animate: { y: 0 } };
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${typeof lineClassName === "function" ? lineClassName(i) : lineClassName}`}
            initial={{ y: "110%" }}
            {...anim}
            transition={{ duration: 1, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Stagger = ({ children, className, delay = 0, gap = 0.08, ...rest }) => (
  <motion.div
    className={className}
    {...rest}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-10% 0px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: gap, delayChildren: delay } } }}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className, y = 32, ...rest }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } } }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Rule = ({ className = "", dark = false }) => (
  <motion.div
    className={`h-px origin-left ${dark ? "bg-white/15" : "bg-ink/10"} ${className}`}
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.2, ease: EASE }}
  />
);
